import React, { Fragment, useEffect, useState } from "react";
import api from "../../services/api";
import { getQueryParams } from "../../helpers/helpers";
import Table from "../components/Table/Table";
import { Button, CircularProgress, Container, Grid } from "@mui/material";
import { LibraryMusic, LocalLibrary } from "@mui/icons-material";

// import LocalLibrary from "@material-ui/icons/LocalLibrary";
// // import Button from 'components/CustomButtons/Button.js';
// import Container from "@material-ui/core/Container";
// import Grid from "@material-ui/core/Grid";
// import CircularProgress from "@material-ui/core/CircularProgress";
// // import { getQueryParams } from "../../helpers";
// import LibraryMusic from "@material-ui/icons/LibraryMusic";
// import { Button } from "@material-ui/core";

let materiaisGeral = [];
let ciclosGeral = [];
let categoriasGeral = [];
let subcategoriasGeral = [];
let filtroCiclo = 0;
let filtroCategoria = 0;
let filtroSubcategoria = 0;

export default function Material({ history, location }) {
  const [carregando, setCarregando] = useState(false);
  const [tabelaMateriais, setTabelaMateriais] = useState({});
  const [tabelasFiltros, setTabelasFiltros] = useState([]);

  useEffect(() => {
    setCarregando(true);

    api
      .get("materiais/listar", { produto: 1 })
      .then((materiais) => {
        materiaisGeral = materiais;
        configurarFiltros(materiais);
        montarTabela();
      })
      .catch((e) => console.log("erro ao carregar materiais", e));
  }, []);

  const configurarFiltros = (materiais) => {
    const parametros = getQueryParams(location.search);

    materiais.forEach((m) => {
      if (
        m.cicloId &&
        ciclosGeral.filter((cg) => cg.id === m.cicloId).length === 0
      ) {
        ciclosGeral.push({ id: m.cicloId, nome: m.cicloNome });
      }

      if (
        m.categoriaId &&
        categoriasGeral.filter(
          (cg) => cg.id === m.categoriaId && cg.cicloId === m.cicloId
        ).length === 0
      ) {
        categoriasGeral.push({
          id: m.categoriaId,
          nome: m.categoriaNome,
          cicloId: m.cicloId,
        });
      }

      if (
        m.subcategoriaId &&
        subcategoriasGeral.filter(
          (sg) => sg.id === m.subcategoriaId && sg.categoriaId === m.categoriaId
        ).length === 0
      ) {
        subcategoriasGeral.push({
          id: m.subcategoriaId,
          nome: m.subcategoriaNome,
          categoriaId: m.categoriaId,
        });
      }
    });

    if (parametros.cic) filtroCiclo = Number(parametros.cic);
    if (parametros.cat) filtroCategoria = Number(parametros.cat);
    if (parametros.sub) filtroSubcategoria = Number(parametros.sub);
  };

  const filtrar = ({ cicloId, categoriaId, subcategoriaId }) => {
    if (cicloId >= 0) {
      filtroCiclo = cicloId;
      filtroCategoria = 0;
      filtroSubcategoria = 0;
    }
    if (categoriaId >= 0) {
      filtroCategoria = categoriaId;
      filtroSubcategoria = 0;
    }
    if (subcategoriaId >= 0) filtroSubcategoria = subcategoriaId;

    const params = `?cic=${filtroCiclo}&cat=${filtroCategoria}&sub=${filtroSubcategoria}`;

    history.push({
      pathname: location.pathname,
      search: params,
    });

    montarTabela();
  };

  const montarTabela = () => {
    const tabelasFiltros = [];

    const tbCiclos = {
      titulo: "Ciclos",
      data: [],
    };

    tbCiclos.data.push([
      <div
        key={0}
        className={`${filtroCiclo === 0 ? "btn-link-selecionado" : "btn-link"}`}
        onClick={() => filtrar({ cicloId: 0 })}
      >
        {"(Todos)"}
      </div>,
    ]);
    ciclosGeral.forEach((ciclo, key) => {
      tbCiclos.data.push([
        <div
          key={key}
          className={`${
            filtroCiclo === ciclo.id ? "btn-link-selecionado" : "btn-link"
          }`}
          onClick={() => filtrar({ cicloId: ciclo.id })}
        >
          {ciclo.nome}
        </div>,
      ]);
    });

    tabelasFiltros.push(tbCiclos);

    const tbCategorias = {
      titulo: "Categorias",
      data: [],
    };

    tbCategorias.data.push([
      <div
        key={0}
        className={`${
          filtroCategoria === 0 ? "btn-link-selecionado" : "btn-link"
        }`}
        onClick={() => filtrar({ categoriaId: 0 })}
      >
        {"(Todas)"}
      </div>,
    ]);

    categoriasGeral
      .filter((cg) => cg.cicloId === filtroCiclo)
      .forEach((categoria, key) => {
        tbCategorias.data.push([
          <div
            key={key}
            className={`${
              filtroCategoria === categoria.id
                ? "btn-link-selecionado"
                : "btn-link"
            }`}
            onClick={() => filtrar({ categoriaId: categoria.id })}
          >
            {categoria.nome}
          </div>,
        ]);
      });

    tabelasFiltros.push(tbCategorias);

    const tbSubcategorias = {
      titulo: "Subcategorias",
      data: [],
    };

    tbSubcategorias.data.push([
      <div
        key={0}
        className={`${
          filtroSubcategoria === 0 ? "btn-link-selecionado" : "btn-link"
        }`}
        onClick={() => filtrar({ subcategoriaId: 0 })}
      >
        {"(Todas)"}
      </div>,
    ]);

    subcategoriasGeral
      .filter((sg) => sg.categoriaId === filtroCategoria)
      .forEach((subcategoria, key) => {
        tbSubcategorias.data.push([
          <div
            key={key}
            className={`${
              filtroSubcategoria === subcategoria.id
                ? "btn-link-selecionado"
                : "btn-link"
            }`}
            onClick={() => filtrar({ subcategoriaId: subcategoria.id })}
          >
            {subcategoria.nome}
          </div>,
        ]);
      });

    tabelasFiltros.push(tbSubcategorias);

    let materiaisExibir = materiaisGeral
      .filter((m) => (filtroCiclo ? m.cicloId === filtroCiclo : true))
      .filter((m) =>
        filtroCategoria ? m.categoriaId === filtroCategoria : true
      )
      .filter((m) =>
        filtroSubcategoria ? m.subcategoriaId === filtroSubcategoria : true
      );

    const tbMateriais = {
      titulo: "Materiais - Bilíngue",
      data: [],
    };

    materiaisExibir.forEach((material) =>
      tbMateriais.data.push([
        <b>{material.nome}</b>,
        material.cicloNome,
        material.categoriaNome,
        material.subcategoriaNome,
        <Visualizar id={material.id} />,
      ])
    );

    setTabelasFiltros(tabelasFiltros);
    setTabelaMateriais(tbMateriais);
    setCarregando(false);
  };

  const Visualizar = ({ id }) => {
    return (
      <Button
        round
        justIcon
        size="sm"
        key={"key"}
        onClick={() => history.push(`/app/materiais/view/${id}`)}
      >
        <LocalLibrary color="primary" />
      </Button>
    );
  };

  return (
    <Container maxWidth="lg" style={{ marginTop: 30 }}>
      {carregando ? (
        <Grid
          container
          style={{ marginBottom: 15, backgroundColor: "white", padding: 10 }}
        >
          <Grid item xs={12} style={{ textAlign: "center" }}>
            <CircularProgress />
          </Grid>
        </Grid>
      ) : (
        <Fragment>
          <Grid
            container
            style={{ marginBottom: 15, backgroundColor: "white", padding: 10 }}
          >
            {tabelasFiltros.map((tabela) =>
              tabela.data && tabela.data.length > 0 ? (
                <Grid item xs={12} md={4} style={{ textAlign: "center" }}>
                  <Table tableHead={[tabela.titulo]} tableData={tabela.data} />
                </Grid>
              ) : (
                <h5>Sem dados para exibir.</h5>
              )
            )}
          </Grid>
          <Grid
            // container
            style={{ marginBottom: 15, padding: 10, textAlign: "right" }}
            // spacing={1}
            // justify="flex-end"
            // alignItems="flex-end"
          >
            {/* <Grid item md={4} style={{ textAlign: 'right' }}> */}
            <Button
              variant="contained"
              color="primary"
              startIcon={<LibraryMusic />}
              href={`/app/materiais/musicas${
                filtroCiclo ? `?cic=${filtroCiclo}` : ""
              }`}
            >
              Músicas
            </Button>
            {/* </Grid> */}
          </Grid>

          {tabelaMateriais.data && tabelaMateriais.data.length > 0 ? (
            <Grid
              container
              style={{
                marginBottom: 15,
                backgroundColor: "white",
                padding: 10,
              }}
            >
              <Grid item xs={12} style={{ textAlign: "center" }}>
                <Table
                  tableHead={[tabelaMateriais.titulo]}
                  tableData={tabelaMateriais.data}
                />
              </Grid>
            </Grid>
          ) : (
            <h5>Sem materiais para exibir.</h5>
          )}
        </Fragment>
      )}
    </Container>
  );
}
